import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-parkeren-bedrijven',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParkerenBedrijven {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M33.99 22H31v-1.92c0-.57-.2-1.06-.6-1.46-.4-.41-.89-.61-1.45-.61h-3.89c-.57 0-1.05.2-1.45.61-.4.41-.6.9-.6 1.46V22H20c-.55 0-1.02.2-1.41.59-.39.39-.58.87-.58 1.43v9.94c0 .56.19 1.04.58 1.44.39.4.86.6 1.41.6h14c.55 0 1.02-.2 1.42-.6.4-.4.59-.88.59-1.44v-9.94c0-.56-.2-1.03-.59-1.43-.39-.39-.87-.59-1.42-.59ZM29 22h-4v-2h4zM25.5 0h-21C2.02 0 0 2.02 0 4.5v21C0 27.98 2.02 30 4.5 30H16v-5.98c0-1.08.4-2.06 1.16-2.83.77-.78 1.74-1.19 2.83-1.19H21c.02-1.06.42-2.03 1.17-2.79A3.96 3.96 0 0 1 25.05 16h3.89c.32 0 .63.05.94.12L30 16V4.5C30 2.02 27.98 0 25.5 0m-9.02 17.99h-4.52v5.03c0 .54-.44.98-.98.98s-.98-.44-.98-.98V7.01c0-.54.44-.98.98-.98h5.5c3.04 0 5.52 2.68 5.52 5.98s-2.48 5.98-5.52 5.98m.09-9.98h-4.61v8h4.61c1.89 0 3.43-1.79 3.43-4s-1.54-4-3.43-4"/>
</svg>

    );
  }
}
